'use client'

import { createContext } from 'react'

import { ItemShippingDetailsModel } from '../../types/item-shipping-details'

export type ShippingDetailsContextType = {
  shippingDetails?: ItemShippingDetailsModel | null
}

const ShippingDetailsProvider = createContext<ShippingDetailsContextType>({
  shippingDetails: null,
})

export default ShippingDetailsProvider
